import { render } from "./UserTrainingEntry.vue?vue&type=template&id=54adde2d&scoped=true"
import script from "./UserTrainingEntry.vue?vue&type=script&lang=js"
export * from "./UserTrainingEntry.vue?vue&type=script&lang=js"

import "./UserTrainingEntry.vue?vue&type=style&index=0&id=54adde2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54adde2d"]])

export default __exports__